/**
 * @generated SignedSource<<4445d146dd5d820faa6b4cc50264435f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PricingGuidancePriceRange = "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type usePdpSharedTracking_item$data = {
  readonly browseUrl?: string | null;
  readonly categoryCode?: string | null;
  readonly contemporaryTrackingString?: string;
  readonly pdpTrackingVpvParams?: any | null;
  readonly pricingGuidance?: {
    readonly priceRange: PricingGuidancePriceRange | null;
  } | null;
  readonly viewInRoomPhotos?: ReadonlyArray<{
    readonly __typename: "viewInRoomPhotos";
  } | null> | null;
  readonly " $fragmentType": "usePdpSharedTracking_item";
};
export type usePdpSharedTracking_item$key = {
  readonly " $data"?: usePdpSharedTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpSharedTracking_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpSharedTracking_item",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "pdpTrackingVpvParams",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "viewInRoomPhotos",
          "kind": "LinkedField",
          "name": "viewInRoomPhotos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceRange",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e6b4363d5ea8e512e95783c31bfc18dc";

export default node;
